export default __webpack_public_path__ + "static/media/Saibaba1.f1758ccd.jpg";